import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { WidgetDataRetentionAndDeletionV0PreviewDto } from './models/widget-data-retention-and-deletion-v0-preview.dto';
import { WidgetDialogService } from '../../../services/widget-dialog.service';
import { of } from 'rxjs';
import { IoniconsFilled, ND } from '@pt/pt-models';

@Component({
  selector: 'pt-widget-data-retention-and-deletion-v0-preview',
  template: `
    <ng-container *ngIf="loading; then LOADING; else PREVIEW"></ng-container>

    <ng-template #LOADING>
      Loading ...
    </ng-template>

    <ng-template #PREVIEW>

      <ng-container *ngIf="noData; then NODATA; else DATA"></ng-container>

      <ng-template #NODATA>
        <pt-widget-nodata [noDataLabel]="noDataLabel"></pt-widget-nodata>
      </ng-template>

      <ng-template #DATA>
        <table
          class="table table-striped table-bordered table-sm">
          <pt-widget-data-retention-and-deletion-header-v0
            class="display-contents"
            [dataHeader]="previewData?.header">
          </pt-widget-data-retention-and-deletion-header-v0>
          <tbody>
          <tr *ngFor="let row of previewData?.value; index as i ">
            <td>
              {{ row.categoryName ? row.categoryName : ND }}
            </td>

            <td style="width: 160px;">
              <span *ngIf="row.retentionPeriodOther">{{ previewData.header.retentionPeriodOther }}</span>
              <span *ngIf="!row.retentionPeriodOther">
                <span class="me-1" *ngIf="row?.retentionPeriod">{{ row?.retentionPeriod }}</span>
                <span *ngIf="row?.retentionPeriodUnit">{{ getUnitLabel(row?.retentionPeriodUnit) }}</span>
              </span>
            </td>

            <td>
              <div class="drad-textarea"
                   #element
                   [ngStyle]="{ 'height': '61px', '-webkit-line-clamp': 3}">
                {{ row?.retentionPeriodReason }}
                <div *ngIf="isOverflow(element)"
                     (click)="openTextArea(previewData.header.retentionPeriodReason, row?.retentionPeriodReason)"
                     [ngStyle]="{'background': i % 2 === 0 ? '#f2f2f2' : '#ffffff'}"
                     class="more-button">
                  ...
                  <button class="btn btn-sm btn-link">
                    <span class="text-lowercase">{{ "LABELS.MORE" | translate }}</span>
                  </button>
                </div>

              </div>
            </td>

            <td>
              <ul class="list-unstyled m-0">
                <li *ngIf="row.anonymization">
                  <pt-icon [key]="IconCheckFilled" class="widget-icon-preview-color"></pt-icon>
                  <span>{{ previewData.header.anonymization }}</span>
                </li>

                <li *ngIf="row.deletion">
                  <pt-icon [key]="IconCheckFilled" class="widget-icon-preview-color"></pt-icon>
                  <span>{{ previewData.header.deletion }}</span>
                </li>

                <li *ngIf="row.pseudonymization">
                  <pt-icon [key]="IconCheckFilled" class="widget-icon-preview-color"></pt-icon>
                  <span>{{ previewData.header.pseudonymization }}</span>
                </li>
              </ul>
            </td>

            <td>
              <div class="drad-textarea"
                   #noteElement
                   [ngStyle]="{'height': '61px','-webkit-line-clamp': 3}">
                {{ row?.note }}
                <div *ngIf="isOverflow(noteElement)"
                     (click)="openTextArea(previewData.header.note, row?.note)"
                     [ngStyle]="{'background': i % 2 === 0 ? '#f2f2f2' : '#ffffff'}"
                     class="more-button">
                  ...
                  <button class="btn btn-sm btn-link">
                    <span class="text-lowercase">{{ "LABELS.MORE" | translate }}</span>
                  </button>
                </div>
              </div>

            </td>
          </tr>
          </tbody>
        </table>
      </ng-template>
    </ng-template>
  `,
  styles: [`
    .drad-textarea {
      position: relative;
      max-width: 200px;
      display: -webkit-box;
      padding: 0 6px;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
      min-height: 63px;
    }

    .more-button {
      position: absolute;
      right: 8px;
      height: 16px;
      font-size: 14px;
      line-height: 14px;
      bottom: 3px;
      color: var(--bs-primary);
      padding: 0 0 0 5px;
      background: #f2f2f2;
    }

    .more-button button {
      margin: 0;
      padding: 0;
      border: 0;
    }
  `]
})
export class WidgetDataRetentionAndDeletionPreviewV0Component implements OnChanges {

  @Input() noDataLabel?: string;
  @Input() previewData: WidgetDataRetentionAndDeletionV0PreviewDto;
  @Input() loading: boolean;

  noData = true;

  ND = ND;

  IconCheckFilled = IoniconsFilled.check;

  constructor(private widgetDialogService: WidgetDialogService) {
  }

  isOverflow(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
  }

  getUnitLabel(uuid: string) {
    if (this.previewData?.unit) {
      const unit = this.previewData.unit.find(u => u.uuid === uuid);
      if (!!unit && !!unit.label) {
        return unit.label;
      }
    }
    return uuid;
  }

  openTextArea(title: string, value: string) {
    const dialog = this.widgetDialogService.runTextArea(
      of(title),
      value,
      false);
    dialog.subscribe(() => {
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.previewData) {
      this.noData = this.previewData?.value?.length === 0;
    }
  }
}
